// MakeCurrentlyPrinting.jsx
import React, { useState } from "react"
import { FaRegHandPaper } from "react-icons/fa"
import { AiOutlineStop } from "react-icons/ai"
import {
  collection,
  query,
  where,
  getDocs,
  writeBatch,
  doc,
  serverTimestamp,
  increment,
} from "firebase/firestore"
import { db } from "../../../firebase/config"
import { Typography } from "antd"

const { Link } = Typography

/**
 * Props:
 *  - machine: "Viva" | "Arsoma" | "Winder"
 *  - orderId: string
 *  - currentlyInUse: boolean
 *  - startedAt?: { seconds: number } | null  // pass record.jobStartedAt{M}
 *  - exclusive?: boolean (default true). For Winder you can pass false.
 */
export default function MakeCurrentlyPrinting({
  machine,
  orderId,
  currentlyInUse,
  startedAt = null,
  exclusive = true,
}) {
  const [loading, setLoading] = useState(false)

  const field = `currentlyInUseFor${machine}`
  const startedField = `jobStartedAt${machine}`
  const stoppedField = `jobStoppedAt${machine}`
  const totalField = `jobTotalSec${machine}`
  const lastField = `jobLastDurationSec${machine}`

  const nowSec = () => Math.floor(Date.now() / 1000)

  const computeDelta = (ts) => {
    const s = ts?.seconds
    if (!s && s !== 0) return 0
    const d = nowSec() - s
    return d > 0 ? d : 0
  }

  const handleClick = async () => {
    if (loading) return
    setLoading(true)
    try {
      const batch = writeBatch(db)
      const thisRef = doc(db, "orders", orderId)

      if (currentlyInUse) {
        // STOP this
        const deltaSec = computeDelta(startedAt)
        batch.update(thisRef, {
          [field]: false,
          [stoppedField]: serverTimestamp(),
          [lastField]: deltaSec,
          [totalField]: increment(deltaSec),
        })
      } else {
        // If exclusive, stop any other active for this machine and add their time
        if (exclusive) {
          const q = query(collection(db, "orders"), where(field, "==", true))
          const snap = await getDocs(q)
          snap.forEach((other) => {
            if (other.id === orderId) return
            const odata = other.data()
            const otherStarted = odata?.[startedField]
            const deltaSec = computeDelta(otherStarted)
            batch.update(other.ref, {
              [field]: false,
              [stoppedField]: serverTimestamp(),
              [lastField]: deltaSec,
              [totalField]: increment(deltaSec),
            })
          })
        }

        // START this
        batch.update(thisRef, {
          [field]: true,
          [startedField]: serverTimestamp(),
          [stoppedField]: null,
          // do not touch totals on start
        })
      }

      await batch.commit()
    } catch (err) {
      console.error("Failed to toggle active order:", err)
    } finally {
      setLoading(false)
    }
  }

  const Icon = currentlyInUse ? AiOutlineStop : FaRegHandPaper
  const title = currentlyInUse ? "Click to stop" : "Click to set as active"

  return (
    <Link>
      <Icon
        onClick={handleClick}
        title={title}
        style={{ cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.5 : 1 }}
      />
    </Link>
  )
}
